import GroupFactory from '@/Factories/GroupFactory';
import ComponentManager from '@/Management/ComponentManager';
import DummyGroupBoxViewModelT from '@/ViewModels/Controls/DummyGroupBoxViewModel';
import DummyGroupBoxT from '@/Controls/DummyGroupBox';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';

export default class DummyGroupFactory extends GroupFactory {

    private DummyGroupBoxViewModel = ComponentManager.getViewModel<typeof DummyGroupBoxViewModelT>('DummyGroupBoxViewModel');
    private DummyGroupBox = ComponentManager.getControl<typeof DummyGroupBoxT>('DummyGroupBox');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    viewModel: DummyGroupBoxViewModelT;

    /**
     * @override 
     */
    protected createViewModel(): DummyGroupBoxViewModelT {
        return new this.DummyGroupBoxViewModel({
            context: this.context,
            layout: this.layout,
            isSummaryViewMode: this.isSummaryViewMode,
            detailViewGroups: this.detailViewGroup.detailViewGroups,
            detailViewItems: this.detailViewGroup.items,
            label: new this.LabelViewModel({
                ergName: this.detailViewGroup.ergName,
                postfix: new this.LabelViewModel({
                    caption: ` (${this.detailViewGroup.uiGenerator})`
                }),
                isErrorLabel: true
            })
        });
    }

    /**
     * @override 
     */
    protected createControl(): DummyGroupBoxT {
        return new this.DummyGroupBox(this.viewModel);
    }
}

ComponentManager.setFactory('DummyGroup', DummyGroupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');